document.addEventListener("DOMContentLoaded", function() {
    axios.get('https://api.ipgeolocation.io/ipgeo?apiKey=ba2843d96ebf4fa29288691ac0a7f511')
        .then(function(response) {
            const country = response.data.country_code2;
            if (country === 'US') {
                document.getElementById('us-content').style.display = 'block';
            } else {
                document.getElementById('non-us-content').style.display = 'block';
            }
        })
        .catch(function(error) {
            console.log(error);
        });
});
